import { Box, Divider, MenuItem, Select, Typography } from '@mui/material';
import { estruturaTipos, type TypeEstruturas } from './risrotEstruturaCatalog';

interface FichaEstruturasI {
	onSelect: (value: TypeEstruturas) => void;
	selectValue: TypeEstruturas | '';
	disabled: boolean;
}

export default function FichaEstruturas({ onSelect, selectValue,disabled }: FichaEstruturasI) {

	return (
		<Box padding={2}>
			<Box >
				<Typography variant='h6'>Anomalias</Typography>
				<Divider />
			</Box>
			<Box padding={2}>
				<Select
					value={selectValue}
					fullWidth
					onChange={(e) => onSelect(e.target.value as TypeEstruturas)}
					label='Estrutura'
					disabled={disabled}
				>
					{estruturaTipos.map((tipo) => (
						<MenuItem key={tipo} value={tipo}>{tipo}</MenuItem>
					))}
				</Select>
			</Box>
		</Box>
	);
}
